import React, { Component } from "react";
import { Modal, Form, Input, Spin, TreeSelect } from "antd";
import { inject, observer } from "mobx-react";
import { importPrivateSitesFromAccountProfile } from "services/privatenetworks";
import co from "co";

const FormItem = Form.Item;
const TextArea = Input.TextArea;

@Form.create({})
@inject("rootStore")
@observer
class ImportFromAccountProfileDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			importingPrivateSites: false
		};
	}
	validateForm = () => {
		return new Promise(resolve => {
			this.internalForm.validateForm((err, vals) => {
				resolve(err);
			});
		});
	};

	importPrivateSites = () => {
		const {
			rootStore: { privateNetworkStore }
		} = this.props;

		const privateNetwork = privateNetworkStore.privateNetwork;

		this.props.form.validateFieldsAndScroll((err, vals) => {
			if (err) {
				return;
			}
			co(
				function*() {
					this.setState({
						importingPrivateSites: true
					});
					const response = yield importPrivateSitesFromAccountProfile(privateNetwork.id, {
						profileId: vals.profileId
					});
					if (response && response.errorList) {
						this.props.form.setFieldsValue({
							importResult: response.errorList
						});
					}
					this.setState({
						importingPrivateSites: false
					});
				}.bind(this)
			);
		});
	};

	hideDialog = () => {
		const {
			rootStore: { privateNetworkStore }
		} = this.props;

		privateNetworkStore.hideImportFromAccountProfileDialog();
	};

	render() {
		const {
			rootStore: { privateNetworkStore }
		} = this.props;

		const ui = privateNetworkStore.ui;

		const spinning = this.state.importingPrivateSites;

		return (
			<Modal
				visible={ui.importFromAccountProfileDialogVisible}
				title="Import Accounts from Account Profiles"
				okText="Import"
				cancelText="Close"
				onCancel={this.hideDialog}
				onOk={this.importPrivateSites}
				destroyOnClose={true}
			>
				<Spin spinning={spinning}>
					<Form>
						<FormItem style={{ marginBottom: 0 }}>
							{this.props.form.getFieldDecorator(
								`profileId`,
								{
									rules: [
										{
											required: true,
											message: "Please select an account profile"
										}
									]
								}
							)(
								<TreeSelect
									showSearch
									style={{ width: 300 }}
									dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
									treeData={this.props.treeData}
									placeholder="Please select an account profile"
									treeDefaultExpandAll
									treeDataSimpleMode
									treeNodeFilterProp="textValue"
									onChange={this.onChange}
								/>
							)}
						</FormItem>
						<FormItem label="Import Result">
							{this.props.form.getFieldDecorator("importResult")(
								<TextArea rows={8} />
							)}
						</FormItem>
					</Form>
				</Spin>
			</Modal>
		);
	}
}

export default ImportFromAccountProfileDialog;
